import { IAppState } from '../../store';

export const selectCanDoOnlineDeal = (state: IAppState) => {
  return state.e2eDealInfo.canDoOnlineDeal;
};
